import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import { highlightBlueBase } from '../../constants/principles'

const StyledA = styled.a`
  text-decoration: none;
  color: ${highlightBlueBase};
  :hover {
    text-decoration: underline;
  }
`

const getContactSubheaderDealerText = (offerCode, dealerIsDirectToKBB, isAssigned, assignedDealerNameDisplay) => {
  if (offerCode === 'tc') {
    return ''
  }
  const dealerInfo = dealerIsDirectToKBB ? 'Your Kelley Blue Book Specialist' : isAssigned ? assignedDealerNameDisplay : 'Up to 3 Participating Dealers'
  return dealerInfo + ' may contact you about your car.'
}

const Pilot1 = ({ experienceState, globalState }) => {
  const { dealerIsDirectToKBB, isAssigned, dealerName, offerCode } = experienceState
  const { environment } = globalState
  const assignedDealerNameDisplay = (offerCode === 'd' || offerCode === 'wc') && dealerName ? dealerName : 'This Participating Dealer'
  const dealerSubtext = getContactSubheaderDealerText(offerCode, dealerIsDirectToKBB, isAssigned, assignedDealerNameDisplay)
  return (
    <Fragment>
      {' '}
      We need your email to send you a copy of your Offer. {dealerSubtext} See{' '}
      <StyledA target="_blank" href={`${environment.kbb_Url}/company/privacy-policy/`}>
        {' '}
        Privacy Statement
      </StyledA>{' '}
      for more.
    </Fragment>
  )
}

const Pilot2 = ({ globalState }) => {
  const { environment } = globalState
  return (
    <Fragment>
      We need your email to send you a copy of your Offer. Your Kelley Blue Book Specialist may contact you about your car. See{' '}
      <StyledA target="_blank" href={`${environment.kbb_Url}/company/privacy-policy/`}>
        {' '}
        Privacy Statement
      </StyledA>{' '}
      for more.
    </Fragment>
  )
}

export default ({ experienceState, globalState }) => {
  const { dealerIsDirectToKBBv2 } = experienceState
  if (dealerIsDirectToKBBv2) {
    return <Pilot2 globalState={globalState} />
  }
  return <Pilot1 experienceState={experienceState} globalState={globalState} />
}
